import styled from 'styled-components';

export const YourOperatorLogoContainer = styled.div`
  max-width: 70px;
  height: 20px;
  margin-bottom: 4px;
  margin-left: 4px;

  &:first-child {
    margin-left: 0;
  }

  img {
    /* Two of the logos are SVGs published without width or height, so they carry no intrinsic size
       and resolve to zero width inside this shrink-to-fit badge. A definite width gives them their
       box back, and leaves the raster logos as they were: the badge is only as wide as they are. */
    width: 100%;
    max-height: 20px;
  }
`;
